import React from 'react';
import {Redirect, Route, Switch, useLocation} from 'react-router-dom';
import {withSentryRouting} from '@sentry/react';
import {useComputedReservationDetails} from './context/computedReservationDetails';
import ConfirmBookingDetailsScreen from './views/ConfirmBookingDetailsScreen';
import AddPersonalDataScreen from './views/AddPersonalDataScreen';
import FinishScreen from './views/FinishScreen';
import ConfirmIdentityGuideScreen from './views/ConfirmIdentityGuideScreen';
import SearchReservationScreen from './views/SearchReservationScreen';
import NewReservation from './views/NewReservation';
import PaymentsScreen from './views/PaymentsScreen';
import HomeScreen from 'views/HomeScreen';
import VerifyModalScreen from 'views/VerifyModalScreen';
import TouristTaxesModal from 'components/Taxes/TouristTaxesModal';
import TouristTaxesScreen from './views/TouristTaxesScreen';
import ProtectScreen from 'views/ProtectScreen';
import EditRegistredGuest from 'views/EditRegistredGuest';
// import LoginModalScreen from 'views/LoginModalScreen';
// import SignupModalScreen from 'views/SignupModalScreen';
// import {ForgotPasswordModal} from 'views/ForgotPasswordModal';
// import {AccountPage} from 'views/AccountPage';
// import {NewPasswordPage} from 'views/NewPasswordPage';
import DocScanScreen from './views/DocScanScreen';
import AddPersonalDataTypeScreen from './views/AddPersonalDataTypeScreen';
import AddPersonalDataScanScreen from './views/VerifyModalScreen/AddPersonalDataScanScreen';
import GuestsIdentityInformation from './views/GuestsIdentityInformation';
import {ExperiencesPage, ExperiencePage} from 'views/ExperiencesPage';
import {RemoteAccessStatusScreen} from './views/RemoteAccessStatusScreen/RemoteAccessStatusScreen';

const SentryRoute = withSentryRouting(Route);

enum PATHS {
  home = '/',
  pay = '/pay',
  protect = '/protect',
  finish = '/finish',
  confirmBooking = '/form/book',
  searchReservation = '/search-reservation',
  newReservation = '/new-reservation',
  experiences = '/experiences',
  verificationStart = '/verification',
  verificationDocumentFront = '/verification/front',
  verificationDocumentBack = '/verification/back',
  verificationSelfie = '/verification/selfie',
  verificationResult = '/verification/result',
  touristTaxes = '/tourist-taxes',
  payTouristTaxes = '/pay/tourist-taxes',
  formPersonalData = '/form/add',
  editGuest = '/form/edit-guest',
  remoteAccessInfoPage = '/remote-access',
}

const UNIVERSAL_PAGES: string[] = [];

function Routes() {
  const location = useLocation();
  const {
    isDocScanDisabled,
    areGuestFieldsDisabled,
    hasGuestMembers,
    hasBiomatchForAllGuests,
  } = useComputedReservationDetails();

  const modalsRoutes = (
    <>
      <Route path="/">
        {/* ------ Future Feature --------- */}
        {/*<LoginModalScreen />*/}
        {/*<SignupModalScreen />*/}
        {/*<ForgotPasswordModal />*/}
        {/* ------ Future Feature --------- */}
        <VerifyModalScreen />
        <TouristTaxesModal />
      </Route>
    </>
  );

  const commonRoutes = [
    <SentryRoute key="HomeScreen" exact path={PATHS.home}>
      <HomeScreen />
    </SentryRoute>,
    <SentryRoute key="FinishScreen" exact path={PATHS.finish}>
      <FinishScreen />
    </SentryRoute>,
    <SentryRoute key="TouristTaxesScreen" path={PATHS.touristTaxes}>
      <TouristTaxesScreen />
    </SentryRoute>,
    <SentryRoute key="PaymentsScreen" path={PATHS.pay}>
      <PaymentsScreen />
    </SentryRoute>,
    <SentryRoute key="ProtectScreen" path={PATHS.protect}>
      <ProtectScreen />
    </SentryRoute>,
    <SentryRoute key="SearchReservationScreen" exact path={PATHS.searchReservation}>
      <SearchReservationScreen />
    </SentryRoute>,
    <Route key="NewReservation" path={PATHS.newReservation}>
      <NewReservation />
    </Route>,
    <Route key="RemoteAccessInfoStatusScreen" path={PATHS.remoteAccessInfoPage}>
      <RemoteAccessStatusScreen />
    </Route>,
  ];

  const commonRegistrationRoutes = [
    // --------------- FUTURE FEATURE ---------------
    // <SentryRoute key="AccountPage" path="/account">
    //   <AccountPage />
    // </SentryRoute>,
    // <SentryRoute key="NewPasswordPage" exact path="/update-password/:token">
    //   <NewPasswordPage />
    // </SentryRoute>,
    // --------------- FUTURE FEATURE ---------------
    <SentryRoute key="ExperiencePageOffer" exact path="/experiences/:offerId">
      <ExperiencePage />
    </SentryRoute>,
    <SentryRoute key="ExperiencesPage" exact path={PATHS.experiences}>
      <ExperiencesPage />
    </SentryRoute>,
    <SentryRoute key="ConfirmBookingDetailsScreen" exact path={PATHS.confirmBooking}>
      <ConfirmBookingDetailsScreen />
    </SentryRoute>,
    <SentryRoute key="AddPersonalDataScreen" exact path={PATHS.formPersonalData}>
      <AddPersonalDataScreen />
    </SentryRoute>,
    <SentryRoute key="ConfirmIdentityGuideScreen" path={PATHS.verificationStart}>
      <ConfirmIdentityGuideScreen />
    </SentryRoute>,
    <SentryRoute key="EditRegistredGuest" exact path={PATHS.editGuest}>
      <EditRegistredGuest />
    </SentryRoute>,
    <SentryRoute key="AddPersonalDataScanScreen" exact path="/form/scan">
      <AddPersonalDataScanScreen />
    </SentryRoute>,
    <SentryRoute key="DocScanScreen" exact path="/scan/doc">
      <DocScanScreen />
    </SentryRoute>,
    <SentryRoute key="GuestsIdentityInformation" exact path="/biomatch-results">
      <GuestsIdentityInformation />
    </SentryRoute>,
    // <Redirect
    //   key="verificationStart"
    //   from="/verification"
    //   to={PATHS.verificationStart}
    // />,
  ];

  const getSwtich = () => {
    if (areGuestFieldsDisabled) {
      return (
        <Switch>
          {commonRoutes}
          <Redirect key="key1" from="/" to="/taxes/setup" />
          <Redirect key="key2" to="/" />
        </Switch>
      );
    }

    if (!hasGuestMembers) {
      return (
        <Switch>
          <SentryRoute key="key3" exact path="/form/book">
            <ConfirmBookingDetailsScreen />
          </SentryRoute>
          <SentryRoute key="key4" exact path="/form/type">
            {isDocScanDisabled ? (
              <Redirect key="key5" to={{pathname: '/form/add', state: location.state}} />
            ) : (
              <AddPersonalDataTypeScreen />
            )}
          </SentryRoute>
          {commonRoutes}
          {commonRegistrationRoutes}
          <Redirect to="/" />
        </Switch>
      );
    }

    const getRedirectUrl = () => {
      if (hasBiomatchForAllGuests) {
        return PATHS.verificationStart;
      }

      if (isDocScanDisabled) {
        return '/form/add';
      }

      return null;
    };

    const redirectUrl = getRedirectUrl();
    return (
      <Switch>
        <SentryRoute key="key6" exact path="/form">
          {redirectUrl ? (
            <Redirect key="key7" to={{pathname: redirectUrl, state: location.state}} />
          ) : (
            <HomeScreen />
          )}
        </SentryRoute>
        {commonRoutes}
        {commonRegistrationRoutes}
        <Redirect key="key8" from="/form" to="/form/add" />
        <Redirect key="key9" to="/" />
      </Switch>
    );
  };

  return (
    <>
      {getSwtich()}
      {modalsRoutes}
    </>
  );
}

export {PATHS, UNIVERSAL_PAGES};
export default Routes;
